import { useEffect, useRef, useState } from 'react';
import { ServiceRegions } from '../components/ServiceRegions';
import { LanguageOptions } from '../components/LanguageOptions';
import { OutputOptions } from '../components/OutputOptions';
import {output} from '../js/FormatOutput';
import { APIInformationModal } from '../components/APIInformationModal';
import { getSubsriptionKey, getRegion, getOutputFormat } from '../js/LocalStorageManager';
import { filePickerChange, FileWithReco, recognize } from '../js/FilePicker';
import { splitAudio } from '../js/AudioSplitter';
// import Visibility from '@material-ui/icons/Visibility';
// import VisibilityOff from '@material-ui/icons/VisibilityOff';
// import IconButton from '@material-ui/core/IconButton';
// import '../style.css';

function Home() {

  const [subscriptionKeyValue, setSubscriptionKeyValue] = useState(getSubsriptionKey())
  const [outputFileName, setOutputFileName] = useState('example')
  const [mediaFormat, setMediaFormat] = useState('.wav')
  const [showApiModal, setShowApiModal] = useState(false)
  const [data, setData] = useState({})
  const [transcribing, setTranscribing] = useState(false)
  const [transcriptionFinished, setTranscriptionFinished] = useState(false)
  const [serviceRegion, setServiceRegion] = useState(getRegion())
  const [outputFormat, setOutputFormat] = useState(getOutputFormat())
  const [languageOptions, setLanguageOptions] = useState('en-US')
  const [file, setFile] = useState<File>()
  const [time, setTime] = useState(0)

  const apiModalRef = useRef<HTMLDivElement>(null)
  const [recos, setRecos] = useState<FileWithReco[]>()

  useEffect(() => {
    localStorage.setItem('subscriptionKey', subscriptionKeyValue ? subscriptionKeyValue : '');
    localStorage.setItem('region', serviceRegion ? serviceRegion : '');
    localStorage.setItem('outputFormat', outputFormat ? outputFormat : '');
  }, [subscriptionKeyValue, serviceRegion, outputFormat])

  const resetTranscription = () => {
    if (transcriptionFinished && !transcribing) {
      setTranscriptionFinished(false);
      var button = document.getElementById("transcriptionButton");
      var finished = document.getElementById('finishedTranscriptionText');
      if (button !== null && finished !== null) {
        button.innerText = "Begin Transcribing!";
        finished.style.visibility = "hidden";
      }
    }
  }

  const startTranscription = async () => {
    if (!transcriptionFinished) {
      if (file === null || file === undefined) {
        return;
      }
      
      var button = document.getElementById('transcriptionButton');
      var select = document.getElementById('filePicker');
      if (button !== null && select !== null) {
        button.innerText = "Starting transcription...";
        select.setAttribute('disabled', '');
      }
      var [files, audio_time] = await splitAudio(file);
      files = files as File[];
      audio_time = audio_time as number;
      setTime(audio_time);
      const recosLocal = filePickerChange(files, setTranscribing, subscriptionKeyValue,
        serviceRegion, languageOptions)
      recognize(recosLocal, outputFileName, mediaFormat, setTranscribing,
        setTranscriptionFinished, setData, audio_time);
      setRecos(recosLocal)
    } else {
      output(data as string[], outputFileName, mediaFormat, outputFormat, time);
    }
  }

  const subscriptionKeyFocus = () => {
    if (subscriptionKeyValue === 'Your Microsoft Speech API Key') {
      setSubscriptionKeyValue('');
    }
  }

  const handleClickOutside = (event: any) => {

    if (apiModalRef.current && apiModalRef?.current !== event.target && !apiModalRef?.current.contains(event.target)) {
      setShowApiModal(false);
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside, true);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, [apiModalRef]);

  return (
    <>
      <br />
      <div className="form">
        <div className="form_element">
          <div>
            <label>MICROSOFT API KEY <a target="_blank" rel='noreferrer' href="https://docs.microsoft.com/en-us/azure/cognitive-services/speech-service/overview#try-the-speech-service-for-free">(how to get one)</a></label> <br />
            <input id="subscriptionKey" type="password" size={40} value={subscriptionKeyValue} onChange={(event) => setSubscriptionKeyValue(event.target.value)}
              onFocus={subscriptionKeyFocus} onBlur={() => setSubscriptionKeyValue(getSubsriptionKey())} />
          </div>
        </div>
        <div className="form_element">
          <div>
            <label>MICROSOFT API REGION</label> <br />
            <ServiceRegions setServiceRegion={setServiceRegion} />
          </div>
        </div>
        <div className="form_element">
          <div>
            <label> LANGUAGE</label> <br />
            <LanguageOptions setLanguageOptions={setLanguageOptions} />
          </div>
        </div>
        <div className="form_element">
          <div>
            <label> OUTPUT FORMAT</label> <br />
            <OutputOptions setOutputFormat={setOutputFormat} />
          </div>
        </div>
        <div className="form_element">
          <div>
            <label> SELECT FILE</label> <br />
            <input type="file" id="filePicker" accept="audio/*" onClick={() => resetTranscription()}
              onChange={(event) => {
                if (event.target.files !== null) {
                  var file = (event.target.files[0] !== null && event.target.files[0] !== undefined) ? event.target.files[0] : null;
                  if (file !== null) {
                    var name = file.name;
                    setOutputFileName(name.substring(0, name.lastIndexOf('.')));
                    setMediaFormat(name.substring(name.lastIndexOf('.'), name.length));
                    setFile(file);
                  }
                }
              }}></input>
          </div>
        </div>
        <div className="form_element">
          <div>
            <button id="transcriptionButton" onClick={() => startTranscription()}
              disabled={transcribing}>Begin transcribing!</button>
          </div>
        </div>
        <div className="form_element" id="finishedTranscriptionText">
          <p>The transcription has automatically been downloaded to your machine. <br />
            If you want a different output format, change it accordingly and press "Download again".<br />
            If you want to start a new transcription, simply choose another file.</p>
        </div>
      </div>
    </>
  );
}
export default Home;